/**
 * File lightbox.js
 * Adds lightbox to WordPress gallery blocks.
 */

import GLightbox from 'glightbox';

// eslint-disable-next-line @babel/new-cap
const lightbox = GLightbox({
    selector: 'data-glightbox',
});

document.querySelectorAll('.wp-block-gallery img').forEach((image) => {
    let src;
    if (image.hasAttribute('data-srcset')) {
        const srcset = image.getAttribute('data-srcset').split(", ");
        src = srcset[srcset.length - 1].split(" ")[0];
    } else if (image.hasAttribute('srcset')) {
        const srcset = image.getAttribute('srcset').split(", ");
        src = srcset[srcset.length - 1].split(" ")[0];
    } else {
        src = image.getAttribute('src');
    }

    let a;
    const hasLink = image.parentElement.nodeName === 'A';
    if (hasLink) {
        a = image.parentElement;
    } else {
        a = document.createElement("a");
    }
    a.setAttribute('href', src);
    a.setAttribute("data-glightbox", 'image');

    if ( !hasLink ) {
        image.parentNode.insertBefore(a, image);
        a.appendChild(image);
    }
});

lightbox.reload();